import createRestfulModule from './restful-module'

export default createRestfulModule({

  state: {
    path: 'banner' // 资源路径
  }

})
